module.exports = __webpack_public_path__ + "img/LG_FC_KnapKind_witteondergrond.66884e7b.png";